import { useState } from "react";
import { Button } from "@/components/ui/button";
import { MemoAIChat } from "./MemoAIChat";
import logo from "@/assets/logo.png";
import { cn } from "@/lib/utils";

interface MemoAIFABProps {
  companyId?: string;
  companyName?: string;
}

export function MemoAIFAB({ companyId, companyName }: MemoAIFABProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Chat Panel */}
      <MemoAIChat
        companyId={companyId}
        companyName={companyName}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />

      {/* FAB Button - positioned above bottom nav on mobile */}
      {!isOpen && (
        <Button
          onClick={() => setIsOpen(true)}
          className={cn(
            "fixed z-50",
            "bottom-20 right-4 sm:bottom-6 sm:right-6",
            "h-14 w-14 rounded-full",
            "bg-gradient-accent shadow-xl hover:shadow-2xl",
            "transition-all duration-300 ease-out",
            "hover:scale-105 active:scale-95",
            "glow-accent"
          )}
          size="icon"
        >
          <img src={logo} alt="Memo" className="h-7 w-7 rounded-lg" />
        </Button>
      )}
    </>
  );
}
